const carouselItems = [
  {
    id: 1,
    title: '顶流男星深夜密会神秘女子，酒店监控画面流出',
    excerpt: '知情人士透露，该男子近期行程与公开通告严重不符，其经纪团队已紧急启动危机公关。事件发生后，相关话题迅速登上各大平台热搜榜首...',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20hotel%20lobby%20at%20night%20with%20dramatic%20red%20ambient%20lighting%2C%20security%20camera%20aesthetic%2C%20mysterious%20atmosphere%2C%20empty%20elegant%20space%2C%20no%20people%2C%20cinematic%20noir%20style&width=900&height=500&seq=carousel-1&orientation=landscape',
    tag: '独家爆料',
    time: '3小时前',
    hot: 9832,
  },
  {
    id: 2,
    title: '综艺节目组内部聊天记录曝光：投票环节涉嫌造假',
    excerpt: '一份来自节目组内部工作群的聊天截图在网络上疯传，内容涉及多轮投票环节的人为操控。节目组官方尚未对此作出正式回应...',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20chat%20conversation%20in%20Chinese%2C%20placed%20on%20a%20dark%20desk%20with%20dramatic%20warm%20lighting%2C%20mysterious%20investigative%20mood%2C%20no%20identifiable%20people&width=900&height=500&seq=carousel-2&orientation=landscape',
    tag: '深度追踪',
    time: '6小时前',
    hot: 7621,
  },
  {
    id: 3,
    title: '知名网红偷税被查，涉案金额或超千万元级别',
    excerpt: '据税务系统内部消息，该网红主播在近三年通过多个关联公司进行收入转移，目前已被税务稽查部门正式立案调查，或将面临巨额罚款...',
    image: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20financial%20documents%20and%20tax%20forms%20on%20a%20dark%20mahogany%20desk%2C%20dramatic%20warm%20lighting%20from%20a%20single%20source%2C%20official%20document%20aesthetic%2C%20serious%20investigative%20mood&width=900&height=500&seq=carousel-3&orientation=landscape',
    tag: '重磅揭秘',
    time: '9小时前',
    hot: 12450,
  },
  {
    id: 4,
    title: '某艺人工作室前员工爆出惊人内幕：合同欺诈成常态',
    excerpt: '多位曾在知名艺人工作室任职的内部人士联合发声，披露行业内普遍存在的合同欺诈、薪资克扣等问题，涉及多位当红艺人及其经纪公司...',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20office%20with%20contracts%20and%20legal%20documents%20scattered%20on%20a%20desk%2C%20warm%20amber%20desk%20lamp%20lighting%2C%20mysterious%20atmosphere%2C%20legal%20drama%20aesthetic%2C%20no%20people&width=900&height=500&seq=carousel-4&orientation=landscape',
    tag: '独家追踪',
    time: '12小时前',
    hot: 5678,
  },
  {
    id: 5,
    title: '电视台主持人私下不当言论录音全网传开，本人已关闭评论',
    excerpt: '一段疑似某省级卫视知名主持人的私下聚会录音在社交平台广泛传播，内容涉及对同行及合作方的负面评价，该主持人社交账号已限制评论...',
    image: 'https://readdy.ai/api/search-image?query=A%20vintage%20radio%20microphone%20on%20a%20dark%20stage%20with%20dramatic%20red%20spotlight%2C%20broadcasting%20studio%20atmosphere%2C%20empty%20chair%2C%20cinematic%20noir%20style%2C%20warm%20suspenseful%20lighting&width=900&height=500&seq=carousel-5&orientation=landscape',
    tag: '最新爆料',
    time: '14小时前',
    hot: 8912,
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="section-anchor py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">焦点爆料</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">重大911吃瓜事件深度追踪，全事件时间线完整呈现</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.slice(0, 3).map((item) => (
            <div key={item.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="aspect-video overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{item.excerpt}</p>
                <div className="flex items-center gap-1 text-accent-500 text-xs">
                  <i className="ri-fire-fill"></i>
                  <span>{item.hot.toLocaleString()} 热度</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
          {carouselItems.slice(3, 5).map((item) => (
            <div key={item.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="aspect-video overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{item.excerpt}</p>
                <div className="flex items-center gap-1 text-accent-500 text-xs">
                  <i className="ri-fire-fill"></i>
                  <span>{item.hot.toLocaleString()} 热度</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}